import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container } from "reactstrap";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    // Flatten and map through the nested routes structure
    return routes.flatMap((prop) =>
      prop.routes
        ? prop.routes.map((subRoute, key) => {
            if (subRoute.layout === "/admin") {
              return (
                <Route
                  path={subRoute.path}
                  element={subRoute.component}
                  key={key}
                  exact
                />
              );
            }
            return null;
          })
        : null
    );
  };

  const getBrandText = (path) => {
    // Handle nested routes for brand text
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].routes) {
        for (let j = 0; j < routes[i].routes.length; j++) {
          if (
            props?.location?.pathname.indexOf(
              routes[i].routes[j].layout + routes[i].routes[j].path
            ) !== -1
          ) {
            return routes[i].routes[j].name;
          }
        }
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/Ordenes",
          imgSrc: require("../assets/img/brand/LOGO-Icontec-2019_hor_pos (1).png"),
          imgAlt: "..",
          width: "600px", // Adjust the width to your desired size
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
